import React from "react";
import * as styles from "./football.module.css";
import BarcelonaLogo from "../Assets/svg/barcelona.svg";
import RealLogo from "../Assets/svg/real-madrid.svg";
import JuveLogo from "../Assets/svg/juventus.svg";
import LiverpoolLogo from "../../static/liverpool.svg";
import BayernLogo from "../../static/bayen-munchen.svg";
import { useState } from "react";
const logo = {
  Barcelona: BarcelonaLogo,
  "Real Madrid": RealLogo,
  Juventus: JuveLogo,
  Liverpool: LiverpoolLogo,
  "Bayern Munich": BayernLogo,
};
const footballData = [
  {
    date: "27 May 2018",
    stadium: "NSC Olimpiyskiy",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Real Madrid",
      Score: 3,
      Shots: 14,
      "Shots on Target": 5,
      Possession: "66%",
      Passes: 645,
      Fouls: 5,
      "Yellow Cards": 0,
      "Red Cards": 0,
    },
    team2: {
      Name: "Liverpool",
      Score: 1,
      Shots: 13,
      "Shots on Target": 2,
      Possession: "34%",
      Passes: 327,
      Fouls: 18,
      "Yellow Cards": 1,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "18 December 2019",
    stadium: "Camp Nou",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Barcelona",
      Score: 0,
      Shots: 9,
      "Shots on Target": 2,
      Possession: "52%",
      Passes: 603,
      Fouls: 5,
      "Yellow Cards": 3,
      "Red Cards": 0,
    },
    team2: {
      Name: "Real Madrid",
      Score: 0,
      Shots: 17,
      "Shots on Target": 4,
      Possession: "48%",
      Passes: 555,
      Fouls: 17,
      "Yellow Cards": 5,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "1 March 2020",
    stadium: "Santiago Bernabéu",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Real Madrid",
      Score: 2,
      Shots: 13,
      "Shots on Target": 5,
      Possession: "44%",
      Passes: 524,
      Fouls: 13,
      "Yellow Cards": 2,
      "Red Cards": 0,
    },
    team2: {
      Name: "Barcelona",
      Score: 0,
      Shots: 9,
      "Shots on Target": 4,
      Possession: "56%",
      Passes: 662,
      Fouls: 10,
      "Yellow Cards": 2,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "15 August 2020",
    stadium: "Estádio da Luz",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Barcelona",
      Score: 2,
      Shots: 7,
      "Shots on Target": 5,
      Possession: "51%",
      Passes: 470,
      Fouls: 13,
      "Yellow Cards": 3,
      "Red Cards": 0,
    },
    team2: {
      Name: "Bayern Munich",
      Score: 8,
      Shots: 26,
      "Shots on Target": 14,
      Possession: "49%",
      Passes: 450,
      Fouls: 22,
      "Yellow Cards": 3,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "24 October 2020",
    stadium: "Camp Nou",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Barcelona",
      Score: 1,
      Shots: 10,
      "Shots on Target": 4,
      Possession: "53%",
      Passes: 595,
      Fouls: 11,
      "Yellow Cards": 3,
      "Red Cards": 0,
    },
    team2: {
      Name: "Real Madrid",
      Score: 3,
      Shots: 15,
      "Shots on Target": 9,
      Possession: "47%",
      Passes: 537,
      Fouls: 13,
      "Yellow Cards": 2,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "29 October 2020",
    stadium: "Juventus Stadium",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Juventus",
      Score: 0,
      Shots: 10,
      "Shots on Target": 0,
      Possession: "41%",
      Passes: 485,
      Fouls: 19,
      "Yellow Cards": 3,
      "Red Cards": 1,
    },
    team2: {
      Name: "Barcelona",
      Score: 2,
      Shots: 13,
      "Shots on Target": 4,
      Possession: "59%",
      Passes: 706,
      Fouls: 16,
      "Yellow Cards": 1,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "9 dec 2020",
    stadium: "Camp Nou",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Barcelona",
      Score: 0,
      Shots: 19,
      "Shots on Target": 7,
      Possession: "60%",
      Passes: 709,
      Fouls: 10,
      "Yellow Cards": 4,
      "Red Cards": 1,
    },
    team2: {
      Name: "Juventus",
      Score: 3,
      Shots: 9,
      "Shots on Target": 4,
      Possession: "40%",
      Passes: 481,
      Fouls: 15,
      "Yellow Cards": 3,
      "Red Cards": 0,
    },
    images: "",
  },
  {
    date: "11 April 2021",
    stadium: "Estadio Alfredo Di Stefano",
    keyPoints: [
      "More assists",
      "Less Possession",
      "And Ramos did same to Salah",
    ],
    team1: {
      Name: "Real Madrid",
      Score: 2,
      Shots: 19,
      "Shots on Target": 7,
      Possession: "69%",
      Passes: 707,
      Fouls: 10,
      "Yellow Cards": 1,
      "Red Cards": 0,
    },
    team2: {
      Name: "Barcelona",
      Score: 1,
      Shots: 14,
      "Shots on Target": 3,
      Possession: "31%",
      Passes: 316,
      Fouls: 16,
      "Yellow Cards": 4,
      "Red Cards": 1,
    },
    images: "",
  },
];

const Card = ({ value, index }) => {
  const [tab, setTab] = useState("stats");
  return (
    <div className={styles.outer} id={`section${index}`}>
      <div className={styles.card}>
        <div className={styles.topRow}>
          <img src={logo[value.team1.Name]} className={styles.logo}></img>
          <h2>{value.team1.Name}</h2>
          <h2 className={styles.score}>{value.team1.Score}</h2>
          <h1>VS</h1>
          <h2 className={styles.score}>{value.team1.Score}</h2>
          <h2>{value.team2.Name}</h2>
          <img src={logo[value.team2.Name]} className={styles.logo}></img>
        </div>
        <div className={styles.bottomRow}>
          <div className={styles.imageSection}>
            <p>{value.date}</p>
            <p>{value.stadium}</p>
          </div>
          <div className={styles.tabsSection}>
            <div className={styles.tabContainer}>
              <button onClick={() => setTab("stats")}>Stats</button>
              <button onClick={() => setTab("keyPoints")}>Key Points</button>
            </div>
            {tab === "stats" ? (
              <div className={styles.tableContainer}>
                <table className={styles.table}>
                  <tr>
                    <th>
                      <img
                        src={logo[value.team1.Name]}
                        className={styles.tableLogo}
                      />
                    </th>
                    <th>Team Stats</th>
                    <th>
                      <img
                        src={logo[value.team2.Name]}
                        className={styles.tableLogo}
                      />
                    </th>
                  </tr>
                  {Object.keys(value.team1).map(row => (
                    <tr>
                      <td>{value.team1[row]}</td>
                      <td>
                        <strong>{row}</strong>
                      </td>
                      <td>{value.team2[row]}</td>
                    </tr>
                  ))}
                </table>
              </div>
            ) : (
              <div>
                <ul>
                  {value.keyPoints.map(value => (
                    <li>{value}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function Football() {
  return (
    <div className={styles.outside}>
      <div className={styles.index}>
        {footballData.map((value, index) => (
          <a href={`#section${index}`}>{index}</a>
        ))}
      </div>
      <div className={styles.out}>
        {footballData.map((value, index) => (
          <Card value={value} index={index} />
        ))}
      </div>
    </div>
  );
}
